"use strict";

module.exports = {
  helperMessage: function (e) {
    return console.log("This message is from NPM package Helper File: ", e), !0;
  }
};